<div [sizeClass]="'XL:_filters-tray'"
     [class._filters-tray-open]="filtersOpen">

    <div class="flex flex-wrap">
        @for (filter of getFiltersForChips(); track filter.id) {
        @for (option of filter.getSelectedOptions(); track option.value) {
        <icon-label class="m-r-3 m-b-3 p-a-2 bg-col-w bg-col-51-m bg-col-51-s cursor-pointer b-radius-4 flex flex-middle"
                    icon="close"
                    [iconRight]="true"
                    [iconSmall]="true"
                    [offset]="1"
                    [textClass]="'c1'"
                    (click)="filter.unselect(option)">
            <span class="no-wrap">{{option.label}}</span>
        </icon-label>
        }
        }
    </div>

    <button *ngIf="listing.filterSelection.length"
            class="s2 m-b m-b-0-m m-b-0-s"
            inlineButton
            (click)="resetFilters()">{{'Clear all' | translate}}</button>


    <listing-sort *ifSize="'MS'"
                  [sort]="listing.sort"
                  [openByDefault]="false"></listing-sort>

    <div class="m-r-10 m-r-0-m m-r-0-s  b-t b-t-0-m b-t-0-s b-col-5"
         [ngStyle]="(app.client.isX || app.client.isL) && {'margin-right': '52px'}">

        @for (filter of listing.getFiltersWithManyCurrentMatches(); track filter.id) {
        @if (filter.filterType === 'attribute-option') {
        <filters [filter]="filter"></filters>
        }
        }
    </div>
</div>
